import { useEffect, useState } from "react"

import { focusOnLogo } from "@garantidos/utils"

import { useProposalContext } from "contexts/proposal"

import * as trackers from "./trackings"

const useSimulation = () => {
  const [isSimulationSubmitting, setIsSimulationSubmitting] = useState(false)

  const { cpfData, proposalData } = useProposalContext()
  const { hashedCpf } = cpfData
  const { simulation_results, financing_term } = proposalData
  const simulationOffers = (simulation_results || []).map((result) => ({
    ...result,
    financing_term
  }))

  const trackDsBackButton = () => {
    trackers.backToHome(hashedCpf)
  }

  useEffect(() => {
    trackers.pageview(hashedCpf)

    focusOnLogo()

    const back = document.getElementById("main-logo")
    back.onclick = () => trackDsBackButton()
  }, [])

  useEffect(() => {
    function scrollToSimulationResults(triesLeft = 5) {
      const element = document.getElementById("simulation-result")
      if (element) {
        element.scrollIntoView({ block: "start", inline: "nearest" })
      } else {
        setTimeout(() => scrollToSimulationResults(triesLeft - 1), 100)
      }
    }

    if (!isSimulationSubmitting) {
      scrollToSimulationResults()
    }
  }, [isSimulationSubmitting])

  return {
    isSimulationSubmitting,
    setIsSimulationSubmitting,
    simulationOffers
  }
}

export default useSimulation
